import { useTranslation } from 'react-i18next'
import {
  Alert,
  AlertProps,
  AlertTitle,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@mui/material'

export type ValveAttachOutRuuviTagToHeaterInstructionsAlertProps = Omit<AlertProps, 'children'>

export default function ValveAttachOutRuuviTagToHeaterInstructionsAlert({
  ...props
}: ValveAttachOutRuuviTagToHeaterInstructionsAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('valve')

  return (
    <Alert severity="info" {...props}>
      <AlertTitle sx={{ mt: 0 }}>
        {t('ValveAttachOutRuuviTagToHeaterInstructionsAlert.title')}
      </AlertTitle>

      <List>
        <ListItem sx={{ py: 1 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>1.</ListItemAvatar>
          <ListItemText primary={t('ValveAttachOutRuuviTagToHeaterInstructionsAlert.stepOne')} />
        </ListItem>
        <ListItem sx={{ py: 1 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>2.</ListItemAvatar>
          <ListItemText primary={t('ValveAttachOutRuuviTagToHeaterInstructionsAlert.stepTwo')} />
        </ListItem>
        <ListItem sx={{ py: 1 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>3.</ListItemAvatar>
          <ListItemText primary={t('ValveAttachOutRuuviTagToHeaterInstructionsAlert.stepThree')} />
        </ListItem>
      </List>
    </Alert>
  )
}
